import { SVGProps, Ref, forwardRef } from 'react';

export const LiferingOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.5 8C.5 4.25 2.375.5 8 .5s7.5 3.75 7.5 7.5-1.875 7.5-7.5 7.5S.5 11.75.5 8m2.513-3.997C2.256 5.056 1.9 6.465 1.9 8s.355 2.942 1.111 3.995l1.855-1.855c-.378-.628-.534-1.385-.534-2.142s.156-1.514.534-2.142zm2.837.857c.54-.33 1.245-.528 2.148-.528s1.608.198 2.148.528l1.857-1.857C11.117 2.35 9.843 1.9 8 1.9c-1.845 0-3.12.45-4.005 1.105zm5.28.996 1.855-1.855c.758 1.053 1.115 2.462 1.115 4 0 1.535-.356 2.943-1.113 3.996L11.13 10.14c.377-.628.534-1.385.534-2.142s-.157-1.514-.534-2.142m-.984 5.28c-.54.33-1.245.528-2.148.528s-1.608-.198-2.148-.528l-1.858 1.858C4.878 13.65 6.153 14.1 8 14.1c1.845 0 3.12-.45 4.005-1.105zM5.732 7.998c0-.708.18-1.267.477-1.624.26-.312.75-.642 1.789-.642s1.528.33 1.788.642c.298.357.478.916.478 1.624s-.18 1.267-.478 1.624c-.26.312-.75.642-1.788.642s-1.528-.33-1.789-.642c-.297-.357-.477-.915-.477-1.624"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
LiferingOutlinedSize16Glyph.displayName = 'LiferingOutlinedSize16Glyph';
